import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
import moduleNavigation from 'cccisd-laravel-assignment/dist/components/navigations/withModules';
import yccCurriculum from '../../components/YCCNavigation/index.js';

const navigations = [moduleNavigation, courseWrapper, yccCurriculum];

export default navigations;
